var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$route.meta.logo))]),_c('logo-image')],1)}
var staticRenderFns = []

export { render, staticRenderFns }